//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    body: String,
    link: String,
    isHiddenMobile: {
      type: Boolean,
      default: false
    }
  }
}
